import { api } from "../config";

export const apiCallsNetworkQuality = {
    Actions: {
        NetworkQuality: async (filters) => {
            try {            
                const fromDateTime = filters.fromDate.hour(filters.fromTime.hour()).minute(filters.fromTime.minute()).second(filters.fromTime.second() || 0);
                const toDateTime = filters.toDate.hour(filters.toTime.hour()).minute(filters.toTime.minute()).second(filters.toTime.second() || 0);
                const fromDateFormat = fromDateTime.toISOString();
                const toDateFormat = toDateTime.toISOString();
                const response = await api.get("NetworkQuality", {
                    params: {
                        Search: filters.search, 
                        IsExcellent: filters.excellent,
                        IsGood: filters.good,
                        IsMedium: filters.medium,
                        IsBad: filters.bad,
                        HasError: filters.error,
                        DateFrom: fromDateFormat, 
                        DateTo: toDateFormat,
                        TimeFrom: filters.fromTime.hour(),
                        TimeTo: filters.toTime.hour(),
                        Gateway: filters.gateway
                    }
                });
                return response.data;
            } catch (error) {
                console.error("API Error:", error.response?.data || error.message);
                throw error;
            }
        },

        LoadGateways: async () => {
            try {
                const response = await api.get("NetworkQuality/load-gateways");
                return response;
            } catch (error) {
                console.error("API Error", error.response?.data || error.message);
            }
        },

        SiteInfo: async (deviceId) => {
            try {
                const response = await api.get(`NetworkQuality/site-info/${deviceId}`)

                return response;
            } catch (error) {
                console.error("API Error", error.response?.data || error.message);
            }
        },

        DeviceInfo: async (deviceId) => {
            try {
                const response = await api.get(`NetworkQuality/device-info/${deviceId}`)
                return response;
            } catch (error) {
                console.error("API Error", error.response?.data || error.message);
            }
        },
    }
}